import { render, staticRenderFns } from "./inforMation.vue?vue&type=template&id=7116648c&scoped=true"
import script from "./inforMation.vue?vue&type=script&lang=js"
export * from "./inforMation.vue?vue&type=script&lang=js"
import style0 from "./inforMation.vue?vue&type=style&index=0&id=7116648c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7116648c",
  null
  
)

export default component.exports